export const IdPs = {
  OTP: 'OTP',
  AWSBuilderID: 'AWSBuilderID',
  AWSSignIn: 'AWSSignIn',
  LoginWithAmazon: 'LoginWithAmazon',
  AmazonFederate: 'AmazonFederate',
};
